import { isNilOrEmpty } from '@pcty/utils';
/**
 * Checks to see if a string is formatted as hh:mm:ss:SSS
 *
 * @param {string} errorMessage The error message to display if the format is invalid
 * @returns {(value: string | number) => Validation}
 * @example
 * validateLongTime('Value must be in 00:00:00:000')('00:00:00:000');
 * //=> { valid: true }
 * validateLongTime('Value must be in 00:00:00:000')('00:60:00:000');
 * //=> { valid: false, errorMessage: 'Value must be in 00:00:00:000' }
 */
export var validateLongTime = function (errorMessage) {
    if (errorMessage === void 0) { errorMessage = 'Invalid format'; }
    return function (value, args) {
        if ((!args.required && isNilOrEmpty(value === null || value === void 0 ? void 0 : value.toString())) || /^\$[0-9]+(?:\.[0-9]{2})?$/.test(value === null || value === void 0 ? void 0 : value.toString())) {
            return { valid: true };
        }
        return {
            valid: false,
            errorMessage: errorMessage,
        };
    };
};
